import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MedicaoRepository } from '@app/data/medicoes';
import { MedicaoModel } from '@app/data/medicoes/models';
import { AuthService } from '@app/infra/auth/auth.service';
import { dateFormat, formatDateWithTimeUTC } from '@app/shared/formatters';
import { autoDownloadFile, base64ToBlob } from '@app/shared/routines';
import { EnumUtil } from '@app/shared/utils';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import { MedicoesController } from '@modules/medicoes/controllers';
import { modal } from '@shared/alerts/modal/modal.alert';
import '@shared/extensions/date.extensions';
import { StatusMedicaoEnum } from './enums';
import { MatDialog } from '@angular/material/dialog';
import { DetalhesMedicaoComponent } from '../../components';
import { ReprovarMedicaoComponent } from '../../components/reprovar-medicao/reprovar-medicao.component';
import { ContratoGrupoRepository } from '@app/data/contrato-grupo/contrato-grupo.repository';
import { ListagemFaturamentoContratoGrupoDTO } from '@app/data/contrato-grupo/dto/listagem-faturamento-contrato-grupo.dto';

@Component({
  selector: 'app-medicoes',
  templateUrl: './medicoes.component.html',
  styleUrls: ['./medicoes.component.scss'],
})
export class MedicaoComponent extends BaseListagemComponent<MedicaoModel> {
  protected loading: boolean = false;
  protected filtros: Campo[] = [
    // {
    //   name: 'CodigoGrupoContrato',
    //   label: 'Grupo Contrato',
    //   type: 'text',
    //   icon: 'insert_drive_file',
    //   width: '20%',
    //   mask: '',
    //   validators: [],
    // },
    // {
    //   name: 'NumeroGrupoContrato',
    //   label: 'Contrato Master',
    //   type: 'text',
    //   icon: 'insert_drive_file',
    //   width: '20%',
    //   mask: '',
    //   validators: [],
    // },
    // {
    //   name: 'Clientes',
    //   label: 'Códigos Clientes',
    //   type: 'text',
    //   width: '20%',
    //   icon: 'person',
    //   validators: [],
    // },
    {
      name: 'SituacoesMedicao',
      label: 'Situação das Medições',
      type: 'select',
      width: '20%',
      value: 'G',
      selectOptions: {
        items: [
          { value: 'A', label: 'Aprovada' },
          { value: 'G', label: 'Gerada' },
          { value: 'C', label: 'Reprovada' },
        ],
      },
      validators: [],
      onChange: (value: string) => {
        this.filtrar(value);
      },
    },

    // {
    //   name: 'condutorMunicipioId',
    //   label: 'Município',
    //   type: 'search',
    //   width: '40%',
    //   searchOptions: {
    //     key: 'descricao',
    //     format: (value: string) => value + '%',
    //     filter: this.municipioRepository.filter.bind(this.municipioRepository),
    //   },
    //   validators: [Validators.required],
    // },
  ];

  protected acoes: Acao[] = [];

  protected colunas: Coluna[] = [
    { name: 'NumeroGrupoContrato', label: 'Contrato Master' },
    // { name: 'CodigoGrupoContrato', label: 'Grupo Contrato' },
    { name: 'Descricao', label: 'Descrição' },
    { name: 'DataCriacaoMedicao', label: 'Data Medição', format: dateFormat },
    // { name: 'CodigoMedicao', label: 'Código Medicao' },
    { name: 'SituacaoMedicao', label: 'Situacão Medição' },
    {
      name: 'DataPrevistaFaturamento',
      label: 'Data Prevista Faturamento',
      format: formatDateWithTimeUTC,
    },
    { name: 'FormasPagamento', label: 'Forma Pagamento' },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Anexos',
          icon: 'attach_file',
          action: this.anexarArquivos.bind(this),
          disabled: !this.authService.hasPermission('multas', 'EDITAR'),
        },
        {
          label: 'Aprovar Medição',
          icon: 'check_circle',
          action: this.aprovarMedicao.bind(this),
          disabled: false,
        },
        {
          label: 'Reprovar Medição',
          icon: 'cancel',
          action: this.reprovarMedicao.bind(this),
          disabled: false,
        },
        {
          label: 'Imprimir Medição',
          icon: 'print',
          action: this.imprimirMedicao.bind(this),
        },
        {
          label: 'Exportar Medição',
          icon: 'upload',
          action: this.exportarMedicao.bind(this),
        },
      ],
    },
  ];

  constructor(
    public medicoesController: MedicoesController,
    private repository: MedicaoRepository,
    private contratosGruposRepository: ContratoGrupoRepository,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private authService: AuthService,
  ) {
    super('Medições - Portal do Cliente', medicoesController);
  }

  public habilitarDesabilitarAprovarReprovar(situacao: any) {
    if (situacao == 'A') {
      if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[1]) {
        this.colunas[6].acoes[1].disabled = true;
      }
      if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[2]) {
        this.colunas[6].acoes[2].disabled = true;
      }
      return;
    }

    if (situacao == 'C') {
      if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[1]) {
        this.colunas[6].acoes[1].disabled = true;
      }
      if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[2]) {
        this.colunas[6].acoes[2].disabled = true;
      }
      if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[4]) {
        this.colunas[6].acoes[4].disabled = true;
      }
      return;
    }

    if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[1]) {
      this.colunas[6].acoes[1].disabled = false;
    }
    if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[2]) {
      this.colunas[6].acoes[2].disabled = false;
    }
    if (this.colunas[6] && this.colunas[6].acoes && this.colunas[6].acoes[4]) {
      this.colunas[6].acoes[4].disabled = false;
    }
  }

  override ngOnInit(): void {
    this.filtrar('G');
    this.paginator.page.subscribe((value) => {
      this.paginationOptions.pageIndex = value.pageIndex;
      this.paginationOptions.pageSize = value.pageSize;
      this.filtrar();
    });

    this.paginator._intl.itemsPerPageLabel = 'Itens por página';
  }

  override filtrar(search?: string) {
    this.habilitarDesabilitarAprovarReprovar(search);

    if (search !== undefined) {
      this.paginationOptions.pageIndex = 0;
      this.paginator.pageIndex = 0;
    }
    const o: any = Object.fromEntries(new URLSearchParams(search));

    const clientes = [];
    const situacoesMedicoes: any[] = [];
    if (o.Clientes) {
      clientes.push(o.Clientes);
    }

    situacoesMedicoes.push(search);

    const params: ListagemFaturamentoContratoGrupoDTO = {
      clienteIds: String(localStorage.getItem("idClienteSelecionado")).split(','),
      situacoesMedicao: situacoesMedicoes,
      grupoContratoIds: o.CodigoGrupoContrato ? [parseInt(o.CodigoGrupoContrato)] : [],
      page: this.paginationOptions.pageIndex + 1,
      offset: this.paginationOptions.pageSize * this.paginationOptions.pageIndex,
      limit: this.paginationOptions.pageSize,
    };

    this.contratosGruposRepository.listagemFaturamento(params).subscribe((res) => {
      this.paginationOptions.length = res?.meta?.itemCount;
      this.items = res?.items?.map((i: { SituacaoMedicao: any }) => {
        const keyStatus: any = i.SituacaoMedicao;
        let situacao = EnumUtil.getEnumValue(StatusMedicaoEnum, keyStatus, 'N/A');
        i.SituacaoMedicao = situacao ?? 'N/A';
        return i;
      });
    });
  }

  public anexarArquivos(medicao: any) {
    this.dialog.open(DetalhesMedicaoComponent, {
      width: '800px',
      height: '600px',
      data: { codigoMedicao: medicao.CodigoMedicao },
    });
  }

  private aprovarMedicao(item: MedicaoModel) {
    this.repository
      .aprovarMedicao({
        medicaoId: item.CodigoMedicao,
      })
      .subscribe({
        next: (res) => {
          modal.fire({
            title: 'Sucesso!',
            text: 'Medição aprovada com sucesso!',
            icon: 'success',
            confirmButtonText: 'OK',
          });
          this.filtrar();
        },
        error: (error) => {
          modal.fire({
            icon: error.icon,
            title: error.title,
            html: error.errors[0].message,
          });
        },
      });
  }

  private reprovarMedicao(item: MedicaoModel) {
    const dialogRef = this.dialog.open(ReprovarMedicaoComponent, {
      width: '1000px',
      height: '600px',
      data: {
        codigoMedicao: item.CodigoMedicao,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((justificativaText) => {
      if (justificativaText !== null) {
        this.repository
          .reprovarMedicao({
            medicaoId: item.CodigoMedicao,
            motivoCancelamento: 49, //TODO refactor
            justificativa: justificativaText,
          })
          .subscribe({
            next: (res) => {
              modal.fire({
                title: 'Sucesso!',
                text: 'Medição reprovada com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK',
              });
              this.filtrar();
            },
            error: (error) => {
              modal.fire({
                icon: error.icon,
                title: error.title,
                html: error.errors[0].message,
              });
            },
          });
      }
    });
  }

  private imprimirMedicao(item: MedicaoModel) {
    this.loading = true;
    this.repository
      .imprimirExportarMedicao({
        medicaoId: item.CodigoMedicao,
        tipoImpressao: 'P',
      })
      .subscribe({
        next: (data) => {
          if (data) {
            const file = base64ToBlob(data.content, 'application/pdf');
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
          } else {
            this.snack.open('Medição inválida', undefined, {
              duration: 4000,
            });
          }
        },
        error: (error) => {
          modal.fire({
            icon: error.icon,
            title: error.title,
            html: error.message,
          });
        },
      })
      .add(() => {
        this.loading = false;
      });
  }

  private exportarMedicao(item: MedicaoModel) {
    this.repository
      .imprimirExportarMedicao({
        medicaoId: item.CodigoMedicao,
        tipoImpressao: 'E',
      } as any)
      .subscribe({
        next: (data) => {
          if (data) {
            const file = base64ToBlob(data.content);
            autoDownloadFile(file, data.filename);
          } else {
            this.snack.open('Medição inválida', undefined, {
              duration: 4000,
            });
          }
        },
        error: (error) => {
          modal.fire({
            icon: error.icon,
            title: error.title,
            html: error.message,
          });
        },
      })
      .add(() => {
        this.loading = false;
      });
  }
}
